// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import { ThemeProvider } from '@/components/layout/ThemeProvider';
import { WebToaster } from '@/components/layout/WebToaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import RemoteAuthCallbackPage from '@/pages/RemoteAuthCallbackPage';
import RemoteControlPage from '@/pages/RemoteControlPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function InvalidRemoteControlRoute() {
  return (
    <main className="text-white flex min-h-screen items-center justify-center bg-zinc-950 px-6">
      <section className="border-white/10 bg-white/[0.06] shadow-black/30 w-full max-w-md rounded-lg border p-6 shadow-2xl">
        <p className="text-xs font-semibold uppercase text-zinc-400">
          Eigent Remote Control
        </p>
        <h1 className="mt-3 text-xl font-semibold">
          Invalid remote control link
        </h1>
        <p className="mt-2 text-sm leading-6 text-zinc-300">
          Open the exact URL generated by the desktop app. If this link was
          copied manually, ask the desktop owner to generate a fresh one.
        </p>
      </section>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <TooltipProvider>
          <Routes>
            <Route
              path="/remote-control/:sessionId"
              element={<RemoteControlPage />}
            />
            <Route
              path="/remote-auth/callback"
              element={<RemoteAuthCallbackPage />}
            />
            <Route path="*" element={<InvalidRemoteControlRoute />} />
          </Routes>
          <WebToaster />
        </TooltipProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
